import { useState } from "react";
import ToolkitAppScroller from "components/BeyondToolkit/ToolkitAppScroller";
import ToolkitGridItem from "components/ToolkitGridItem";
import ToolkitVideoPlayer from "components/ToolkitVideoPlayer";
import { episodes, ReadAlongEpisode } from "data/readAlongEpisodes";
import { closeWebview } from "src/pods/webviewInit";
import { logParentToolkitEvent } from "src/utils/logEvent";
import { READ_ALONGS } from "utils/beyondToolkitTools";
import { useQuotaActivity } from "src/pages/beyondToolkit/useQuotaActivity.vm";
import styles from "./index.module.css";

const useVmDefault = () => useQuotaActivity("readAlongs");

type ReadAlongsProps = {
  di?: { useVm?: typeof useVmDefault };
};

function ReadAlongs({ di }: ReadAlongsProps) {
  const useVm = di?.useVm ?? useVmDefault;
  const { recordUsage } = useVm();

  const [episodeSelected, setEpisodeSelected] = useState<ReadAlongEpisode | null>(null);
  const [quotaReached, setQuotaReached] = useState(false);

  const { title, imgSrc } = READ_ALONGS();

  return (
    <div>
      {episodeSelected == null ? (
        <ToolkitAppScroller title={title} variant="readAlongs" imgSrc={imgSrc}>
          <div className={styles.grid}>
            {episodes.map((episode, i) => {
              return (
                <ToolkitGridItem
                  key={i}
                  index={i}
                  title={episode.title}
                  subTitle={`${episode.seriesTitle} • ${episode.duration} min`}
                  imgSrc={episode.imgSrc}
                  imgZoomed
                  noBorder
                  onItemClick={() => {
                    logParentToolkitEvent({ eventName: `read_alongs.${episode.loggingId}.tap` });
                    setEpisodeSelected(episode);
                  }}
                />
              );
            })}
          </div>
        </ToolkitAppScroller>
      ) : (
        <ToolkitVideoPlayer
          videoSrc={episodeSelected.videoSrc}
          onClose={() => {
            setEpisodeSelected(null);
            if (quotaReached) {
              closeWebview();
            }
          }}
          sendUsage={async () => {
            const { exhausted } = await recordUsage();
            if (exhausted) setQuotaReached(true);
          }}
        />
      )}
    </div>
  );
}

export default ReadAlongs;
